import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const EXAMPLEBLOCK_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Titre" },
  "baseline",
  "width",
  "background_image",
  "display_back_icon",
  "background_color_hex",
  "background_color_palette",
  "background_color_default",
  "shop",
  "product_labels"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  exampleBlockDescriptor: _generatedExampleBlockDescriptor,
  exampleBlockBlocDefinition,
  exampleBlockDashboardLayout,
  exampleBlockConfig,
  exampleBlockResolveConfig,
  exampleBlockProperties,
} = doodBlockConfig(
  {
    name: "Suggestions",
    componentType: 'ExampleBlockComponent',
    category: 'content',
    description: "Suggestions.",
    keywords: [],
    sharedFields: {}
,
    slots: [
      {
        key: 'widgets',
        name: "pages.blocks.example.widgets.label",
        accept: 'explicitOnly',
        allowedTypes: ["Widget.*", "SpecialWidgetBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'allowed_block_demo',
        name: "pages.blocks.example.allowed-block-demo.label",
        accept: 'all',
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    baseline: propertyValue({
      type: 'text',
      value: '',
      options: {
        "label": "Baseline",
        "placeholder": "",
        "max_length": 100
      }
    }),
    width: propertyValue({
      type: 'select',
      value: "full",
      options: {
        "label": "Largeur",
        "multiple": false,
        "choices": [
          {
            "value": "half",
            "label": "1/2"
          },
          {
            "value": "full",
            "label": "2/2"
          }
        ]
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        "label": "pages.blocks.example.background-image.label",
        "help": "pages.blocks.example.background-image.help"
      }
    }),
    display_back_icon: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        "label": "Display \"back\" icon"
      }
    }),
    background_color_hex: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#DADADA"},
      options: {
        "label": "Background color"
      }
    }),
    background_color_palette: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-100"},
      options: {
        "label": "Background color"
      }
    }),
    background_color_default: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        "label": "Background color"
      }
    }),
    shop: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        "label": "Choose one shop",
        "max": 2
      }
    }),
    product_labels: propertyValue({
      type: 'product_label_picker',
      value: '',
      options: {
        "label": "Choose product labels",
        "max": 5
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["baseline", "width", "background_image", "display_back_icon", "background_color_hex", "background_color_palette", "background_color_default", "shop", "product_labels", "widgets", "allowed_block_demo"],
          },
        ],
      },
    ],
  })
);

export function exampleBlockDescriptor(): IBlockDescriptor;
export function exampleBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function exampleBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedExampleBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedExampleBlockDescriptor, exampleBlockProperties, fieldOrder);
}

export {
  exampleBlockBlocDefinition,
  exampleBlockDashboardLayout,
  exampleBlockProperties,
  exampleBlockConfig,
  exampleBlockResolveConfig,
};

export type ExampleBlockConfig = typeof exampleBlockConfig;
